module.exports = __webpack_public_path__ + "static/media/logo-white.45326bd3.svg";